module.exports = __webpack_public_path__ + "img/instructor3.fe25a2d9.png";